export default {
  'menu.welcome': 'Welcome',
  'menu.CAT': 'Comparative Analysis Tool',
  'menu.Analytics': 'Analytics',
  'menu.Custom Analytics': 'Custom Analytics',
  'menu.Daily Companion': 'Daily Companion',
  'menu.Recently Added 483s': 'Recently Added 483s',
  'menu.USFDA Inspections': 'USFDA Inspections',
  'menu.Global Agencies Inspections': 'Global Agencies Inspections',
  'menu.Global Agencies Inspections.MHRA/EU Inspections': 'MHRA/EU Inspections',
  'menu.Global Agencies Inspections.PMDA Inspections': 'PMDA Inspections',
  'menu.Global Agencies Inspections.SwissMedic GMDP': 'SwissMedic GMDP',
  'menu.Global Agencies Inspections.Health Canada Inspections': 'Health Canada Inspections',
  'menu.Global Agencies Inspections.RRA Inspections': 'Remote Regulatory Assessments',
  'menu.Global Site Intelligence': 'Global Site Intelligence',
  'menu.User Management': 'User Management',
  'menu.Notifications': 'Notifications',
  'menu.Data Typing': 'Data Typing',
  'menu.MHRA/EU Inspections': 'MHRA/EU Inspections',
  'menu.PMDA Inspections': 'PMDA Inspections',
  'menu.SwissMedic GMDP': 'SwissMedic GMDP',
  'menu.Health Canada Inspections': 'Health Canada Inspections',
  'menu.RRA Inspections': 'Remote Regulatory Assessments',
  'menu.investigators': 'USFDA Investigators',
  'menu.sites': 'USFDA Sites',
  'menu.Trending483': 'Trending 483',
  'menu.companyProfile': 'Company Profile',
  'menu.observations': 'Observation Search',
  'menu.observations.observations': 'Advanced',
  'menu.observations.observationsQS': 'QualitySystems',
  'menu.observations.observationsFTS': 'Text',
  'menu.observations.Saved Observation Search': 'Saved Observation Search',
  'menu.observations.observationsCS': 'CFR Citation',
  'menu.observations.observationsISO': 'ISO 13485',
  'menu.observations.Observation Intelligence': 'Observation Intelligence',
  'menu.enforcement_actions': 'Enforcement Actions',
  'menu.enforcement_actions.warning-letters': 'Warning Letters',
  'menu.enforcement_actions.Import Alerts': 'Import Alerts',
  'menu.enforcement_actions.Recall Data': 'Recall Data',
  'menu.enforcement_actions.FDA Debarment': 'FDA Debarment',
  'menu.MeDeusa': 'MeDeusa',
  'menu.MeDeusa.MyProfile': 'MyProfile',
  'menu.MeDeusa.Recall': 'Recall',
  'menu.MeDeusa.FDA 510(k)': 'FDA 510(k)',
  'menu.MeDeusa.Registration_listing': 'Registration_listing',
  'menu.MeDeusa.MAUDE': 'MAUDE',
  'menu.drugAnalytics': 'Drug Search',
  'menu.Watchlist Tracking': 'Watchlist Tracking',
  'menu.My Hub': 'My Hub',
  'menu.My Hub.My WatchList': 'My WatchList',
  'menu.My Hub.My Saved Searches': 'My Saved Searches',
  'menu.My Hub.My Notifications': 'My Notifications',
  'menu.My Hub.My Notes': 'My Notes',
  'menu.Supply Chain': 'Supply Chain',
  'menu.Supply Chain.Monitoring': 'Monitoring',
  'menu.Supply Chain.Supplier Profile': 'Supplier Profile',
  'menu.Supply Chain.Product Profile': 'Product Profile',
  'menu.Supply Chain.Product Monitoring': 'Product Monitoring',
  'menu.NewsFeed': 'News Feed',
  'menu.FdaCRLHistory': 'Complete Response Letters',
  'menu.internalAudit': 'Internal Audit (Coming Soon)',
  'menu.andasearch': 'ANDA Search (Coming Soon)',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.login': 'Login',
  'menu.passwordReset': 'Reset Password',
  'menu.signup': 'Sign Up',
  'menu.register': 'Register',
  'menu.register.result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.weekly_updates': 'Weekly Updates',
  'menu.Clinical Trials': 'Clinical Trials',
};
